
import React, { useState } from 'react';
import { Typography } from '@material-ui/core';
import Button from "storybookComponents/Button";
import Switch from '@material-ui/core/Switch';
import { MenuList as Menu } from './menuList';
import { getDate } from "content/utils/commonParsing";

export default React.memo(({
  item,
  classes,
  onEdit,
  onActiveClick,
  onPreviewCallback,
  onDuplicateCallback
}) => {

  const [active, setActive] = React.useState(item.active)

  const handleClick = async (item) => {
    setActive(!active)
    let response = await onActiveClick(item, active);
    setActive(response)
  }

  return (
    <tr className={classes.listBorder}>
      <td colSpan={2}>
        <Typography className={classes.eventname} variant='body1'>
          {item.title}
        </Typography>

        <Typography className={classes.time} variant='subtitle1'>
          {item.propertyName}
        </Typography>
      </td>
      <td>
        {getDate(item.createdAt)}
      </td>
      <td>
        {item.residentsCount}
      </td>
      <td>
        {item.friendsCount}
      </td>
      <td>
        <Switch
          checked={active}
          onChange={handleClick.bind(this, item)}
          color="primary"
          name="checkedB"
          inputProps={{ 'aria-label': 'primary checkbox' }}
        // classes={{
        //   track: classes.switchTrack,
        //   thumb: classes.switchThumb
        // }}
        />
      </td>
      <td className="align-right">
        <Button
          variant='secondary'
          size='sm'
          color='secondary'
          className={classes.btn}
          onClick={onEdit.bind(this, item.id)}
        >
          Edit
      </Button>
      </td>
      <td className={classes.menuItem}>
        <Menu
          item={item}
          onPreviewCallback={onPreviewCallback}
          onDuplicateCallback={onDuplicateCallback}
        />
      </td>
    </tr>

  )
})